module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Part1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART ONE – BACKGROUND")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01"
    }
  }, [_vm._v("Methodology")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03"
    }
  }, [_vm._v("Social and Economic Background")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter04"
    }
  }, [_vm._v("Barnsley in the 1800s")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter05"
    }
  }, [_vm._v("The 1842 Royal Commission Report")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter06"
    }
  }, [_vm._v("The Oaks (Ardsley Main) Colliery and 1847 Explosion")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Colliers’ Relief Fund and its Administration")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Information about other Relevant Colliery Disasters and Accidents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART TWO – THE VICTIMS")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Seventy-three dead:")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richard and Thomas Beardshall")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Bedford")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Billington")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Francis Birtles")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James and Thomas Brown")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Buckley")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William Carlton")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robert and James Chadwick")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richard and John Cooke")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peter and John Day")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew Denton")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Dyson")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joseph Fearnley")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thomas Foundhere")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James and John Galloway")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry Gardner")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Gelder")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George and Joseph Gilberthorpe")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles Haigh")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Harper")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Hartley")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robert Hazle (Hessle)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Hinchcliffe")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Hitchen")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aaron Hobson")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richard Hodgson")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abraham Holland")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Hough")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Jessop")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Kell(e)y")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William Kirk")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Lees")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaac, Samuel and Matthew Lindley (Linley)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Littlewood")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Matthewman")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51_Chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abraham and Vincent Matthews")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52_Chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robert McLear")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53_Chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel Mellor")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/54_Chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Parker")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/55_Chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Peach")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/56_Chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Riley")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/57_Chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William, William, John and Luke Roe (Wroe)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/58_Chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William Rushforth")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/59_Chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William Scales")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/60_Chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Sedgwick")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/61_Chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward Stanfield")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/62_Chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Thomas, Charles and Joseph Steel")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/63_Chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joseph and James Turton")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/64_Chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Wainwright")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/65_Chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William Walton")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/66_Chapter59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James, William and George Whiteley")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/67_Chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ezra Winter")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/68_Chapter61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Woodcock")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/69_Chapter62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joseph and David Woodhead")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocb"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Three men injured:")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/70_Chapter63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward Burrows")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/62_Chapter55#lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thomas Steel")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/71_Chapter64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bernard Wogan")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/72_Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/73_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/74_Map",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1800 Maps of Barnsley")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a03f5252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0